<template>
  <user-login-wrapper>
    <el-card class="full-card" shadow="always">
      <template #header>
        <div v-if="detail != null">
          <jr-applicant-title
            titleName="境界立会申請件名詳細"
            :applicantNumber="detail.applicant_number"
            :applicantTitle="detail.applicant_title"
          />
        </div>
      </template>
      <template #default>
        <double-scroll>
          <template #left>
            <boundary-info
              mode="detail"
              v-if="requestHeaderId"
              :requestHeaderId="requestHeaderId"
              @update:form="detail = $event"
            />
          </template>
          <template #right>
            <el-collapse class="right-panels double-scroll-padding" v-if="requestHeaderId && detail != null">
              <!-- 事前調査 -->
              <input-group-dark title="事前調査" class="preliminary_survey">
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="状態">
                    <statuses
                      v-model="detail.boundary.preliminary_survey_status"
                      :statuses="preliminarySurvey"
                      class="preliminary_survey_status"
                    />
                  </el-descriptions-item>
                  <el-descriptions-item label="実施日">
                    <span
                      v-if="detail.boundary.preliminary_survey_date == null"
                      class="text-xs preliminary_survey_date"
                    >
                      未定
                    </span>
                    <date-display
                      v-else
                      :date="detail.boundary.preliminary_survey_date"
                      type="date"
                      size="small"
                      class="preliminary_survey_date"
                    />
                  </el-descriptions-item>
                </el-descriptions>
                <el-collapse-item title="事前調査内容詳細">
                  <div class="action-buttons flex text-xs">
                    <router-link
                      :to="{
                        name: 'PreliminarySurveyEdit',
                        params: {
                          request_header_id: detail.request_header_id,
                        },
                      }"
                    >
                      <jr-button-for-jrqc>結果入力</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'OpinionInquiry',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.B_PS_OPINION,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>意見照会</jr-button-for-jrqc>
                    </router-link>
                  </div>
                  <Suspense>
                    <message-history
                      :requestHeaderId="detail.request_header_id"
                      :messageGroup="MessageGroups.B_PRELIMINARY_SURVEY"
                    />
                  </Suspense>
                </el-collapse-item>
              </input-group-dark>

              <!-- 現地立会 -->
              <input-group-dark title="現地立会" class="witness">
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="状態">
                    <statuses v-model="detail.boundary.witness_status" :statuses="witness" class="witness_status" />
                  </el-descriptions-item>
                  <el-descriptions-item label="実施日">
                    <span v-if="detail.boundary.witness_date == null" class="text-xs witness_date">未定</span>
                    <date-display
                      v-else
                      :date="detail.boundary.witness_date"
                      type="date"
                      size="small"
                      class="witness_date"
                    />
                  </el-descriptions-item>
                </el-descriptions>
                <el-collapse-item title="現地立会内容詳細">
                  <div class="action-buttons flex text-xs">
                    <router-link
                      :to="{
                        name: 'JrScheduleMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.B_WS_JR_ADJUST_DATE,
                        },
                      }"
                    >
                      <jr-button-for-jrqc>JR関係者日程調整</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'ScheduleMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.B_WS_ADJUST_DATE,
                        },
                      }"
                    >
                      <jr-button-for-jrqc>協議先日程調整</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'ScheduleDecide',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.B_WS_DECIDE_DATE,
                        },
                      }"
                    >
                      <jr-button-for-jrqc>日程確定</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.B_WS_DECIDE_DATE_NOTICE,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>日程確定連絡</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.B_WS_JR_DECIDE_DATE_NOTICE,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>JR日程確定連絡</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'WitnessEdit',
                        params: {
                          request_header_id: detail.request_header_id,
                        },
                      }"
                    >
                      <jr-button-for-jrqc>結果入力</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'OpinionInquiry',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.B_WS_OPINION,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>意見照会</jr-button-for-jrqc>
                    </router-link>
                  </div>
                  <Suspense>
                    <message-history
                      :requestHeaderId="detail.request_header_id"
                      :messageGroup="MessageGroups.B_WITNESS"
                    />
                  </Suspense>
                </el-collapse-item>
              </input-group-dark>

              <!-- 境界立会状況 -->
              <input-group-dark title="境界立会状況" class="witness">
                <el-descriptions :column="2" border size="small">
                  <el-descriptions-item label="境界確認申請受付日">
                    <span
                      v-if="detail.boundary.boundary_confirm_applicant_receipt_date == null"
                      class="text-xs boundary_confirm_applicant_receipt_date"
                    >
                      未
                    </span>
                    <date-display
                      v-else
                      :date="detail.boundary.boundary_confirm_applicant_receipt_date"
                      type="date"
                      size="small"
                      class="boundary_confirm_applicant_receipt_date"
                    />
                  </el-descriptions-item>
                  <el-descriptions-item label="調査開始日">
                    <span v-if="detail.boundary.research_start_date == null" class="text-xs research_start_date">
                      未
                    </span>
                    <date-display
                      v-else
                      :date="detail.boundary.research_start_date"
                      type="date"
                      size="small"
                      class="research_start_date"
                    />
                  </el-descriptions-item>
                  <el-descriptions-item label="境界確認書受付日">
                    <span
                      v-if="detail.boundary.boundary_confirm_receipt_date == null"
                      class="text-xs boundary_confirm_receipt_date"
                    >
                      未
                    </span>
                    <date-display
                      v-else
                      :date="detail.boundary.boundary_confirm_receipt_date"
                      type="date"
                      size="small"
                      class="boundary_confirm_receipt_date"
                    />
                  </el-descriptions-item>
                  <el-descriptions-item label="発送日">
                    <span v-if="detail.boundary.send_date == null" class="text-xs send_date"> 未 </span>
                    <date-display v-else :date="detail.boundary.send_date" type="date" size="small" class="send_date" />
                  </el-descriptions-item>
                  <el-descriptions-item label="用地管理システム登録日">
                    <span
                      v-if="detail.boundary.land_system_register_date == null"
                      class="text-xs land_system_register_date"
                    >
                      未
                    </span>
                    <date-display
                      v-else
                      :date="detail.boundary.land_system_register_date"
                      type="date"
                      size="small"
                      class="land_system_register_date"
                    />
                  </el-descriptions-item>
                </el-descriptions>
                <div class="action-buttons flex text-xs py">
                  <router-link :to="{ name: 'BoundaryStatusEdit', params: { request_header_id: requestHeaderId } }">
                    <jr-button-for-jrqc>状況入力</jr-button-for-jrqc>
                  </router-link>
                </div>
              </input-group-dark>
            </el-collapse>
          </template>
        </double-scroll>
      </template>
    </el-card>
  </user-login-wrapper>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import InputGroupDark from '@/components/layout/InputGroupDark.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import Statuses from '@/components/others/Statuses.vue'
import MessageHistory from '@/components/others/MessageHistory.vue'
import JrButtonForJrqc from '@/components/jr-parts/JrButtonForJrqc.vue'
import BoundaryInfo from '@/components/layout/BoundaryInfo.vue'
import DateDisplay from '@/components/displays/DateDisplay.vue'
import JrApplicantTitle from '@/components/jr-parts/JrApplicantTitle.vue'

import { witness, preliminarySurvey } from '@/constants/statuses'
import { useRoute, useRouter } from 'vue-router'
import { RequestHeaderBoundaryDetailForm } from '@/types/forms'
import { MessageGroups } from '@/constants/messageGroups'
import { MessageTypes } from '@/constants/messageTypes'

/**
 * 境界立会申請件名詳細
 */
export default defineComponent({
  name: 'BoundaryDetail',
  components: {
    InputGroupDark,
    DoubleScroll,
    Statuses,
    MessageHistory,
    JrButtonForJrqc,
    UserLoginWrapper,
    BoundaryInfo,
    DateDisplay,
    JrApplicantTitle,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const requestHeaderId = computed(() => {
      return Number(route.params.request_header_id)
    })
    const detail = ref<RequestHeaderBoundaryDetailForm | null>(null)

    if (Number.isNaN(requestHeaderId.value)) {
      router.push({ name: 'NotFound' })
    }

    return {
      requestHeaderId,
      preliminarySurvey,
      witness,
      detail,
      MessageGroups,
      MessageTypes,
    }
  },
})
</script>

<style lang="scss" scoped>
.el-collapse {
  border-top: none;
  border-bottom: none;
}
.el-collapse-item {
  ::v-deep(.el-collapse-item__content) {
    padding-bottom: 0px !important;
  }
  ::v-deep(.el-collapse-item__wrap) {
    border-top: none !important;
    border-bottom: none !important;
  }
  ::v-deep(.el-collapse-item__header) {
    border-top: none !important;
    border-bottom: none !important;
  }
}

.action-buttons {
  flex-wrap: wrap;
  margin-left: -5px;
  margin-right: -5px;
  margin-top: -5px;
  padding-bottom: 10px;
  .el-button {
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
  }
}

.input-group-dark {
  margin-top: 8px;
  margin-bottom: 8px;
}
.right-panels {
  margin-top: -8px;
  margin-bottom: -8px;
}

.el-descriptions {
  ::v-deep(.el-descriptions__label) {
    width: 140px;
  }
}
</style>
